import { filterSchema } from './serie-list-filter.schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';

export function SerieListFilter() {
  const { register } = useFilterForm(filterSchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på namn..." aria-label="Sök" />
    </Table.Bar>
  );
}
